import React from 'react';
import { chromeIntentUrl } from '../utils/inAppBrowser';
import { trackEvent } from '../utils/analytics';

// Shown only to visitors inside an email/social app's built-in browser.
// "arrival" runs on step 1, before anything is typed, so switching browsers
// costs nothing. "review" sits above the PayPal button and points to the
// invoice fallback instead, because switching browsers there would lose the
// order they just filled in.
export default function InAppBrowserNotice({ info, variant }) {
  if (!info) return null;

  const where = info.app ? `the ${info.app} app's built-in browser` : "this app's built-in browser";

  if (variant === 'review') {
    return (
      <div className="inapp-notice">
        <div className="inapp-notice-title">Payment window not opening?</div>
        You're in {where}, which can block the PayPal window. If it doesn't open
        or keeps loading, tap <strong>Email me an invoice</strong> below and we'll
        send you one to pay by card. Your order details are already filled in.
      </div>
    );
  }

  return (
    <div className="inapp-notice">
      <div className="inapp-notice-title">For the smoothest checkout, use your browser</div>
      You're viewing this in {where}, which can stall PayPal checkout.{' '}
      {info.os === 'android' ? (
        <>
          Open this page in Chrome before you start.
          <div>
            <a
              className="btn btn-primary inapp-notice-btn"
              href={chromeIntentUrl(window.location.href)}
              onClick={() => trackEvent('ad_inapp_open_chrome', { ad_inapp_app: info.app || 'unknown' })}
            >
              Open in Chrome
            </a>
          </div>
        </>
      ) : info.os === 'ios' ? (
        <>
          Before you start, tap the <strong>&bull;&bull;&bull;</strong> or share icon and
          choose <strong>Open in Safari</strong> (or <strong>Open in browser</strong>).
        </>
      ) : (
        <>Open this page in your regular web browser before you start.</>
      )}
      <div className="inapp-notice-hint">
        Prefer to stay here? That's fine: if payment gets stuck, you can ask us to email you an invoice instead.
      </div>
    </div>
  );
}
